module.exports = __webpack_public_path__ + "img/yellowy1.43b09a18.jpg";